module.exports = (el) => {
  let currentTab = '';
  let redirect = false;
  let defaultTab = 'myProfile';
  const menuEl = $(el);

  function tabClick(e) {
    const tab = $(this).attr('href').split('#')[1];

    if (redirect) {
      window.location = `/my-account?tab=${tab}`;
    } else {
      history.pushState(null, null, `?tab=${tab}`);
      menuEl.trigger('tab-activated', tab);
      e.preventDefault();
    }
  }

  function activateTab(tab) {
    currentTab = tab;
    const tabEl = menuEl.find(`li a[href="#${tab}"]`);
    tabEl.tab('show');
  }

  function getCurrentTab() {
    return currentTab;
  }

  function setRedirect(val) {
    redirect = !!val;
  }

  function setDefaultTab(tab) {
    defaultTab = tab;
  }

  function initialize() {
    if (location.search.indexOf('tab=') !== -1) {
      const tabName = location.search.split('tab=')[1].split('&')[0];

      activateTab(tabName);
    } else if (defaultTab !== false) {
      activateTab(defaultTab);
    }
  }

  menuEl.find('.my-account-tabs li a').click(tabClick);

  return {
    activateTab,
    getCurrentTab,
    setRedirect,
    setDefaultTab,
    initialize,
    el: menuEl
  };
};
